<script>
  import API from '../Stores/API';
  import Trail from '../Components/Trail';
  import View from '../Stores/View';

  let context = '';
  let subscription = $View.config.subscription;
  let maintenance = $View.config.maintenance;
</script>

{#if $API.data}
  {#if subscription}
    <Trail path="{[['Account', () => View.setView('dashboard')], [subscription.plot.departed.name, () => View.setView('subscription', {subscription})], [maintenance.date]]}"/>
  {:else}
    <Trail path="{[['Account', () => View.setView('dashboard')], [maintenance.date]]}"/>
  {/if}

  <section class="pt-6 bg-dark">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-12 text-center text-white">
          <h1 class="display-3 mb-4"><span class="text-underline-warning text-capitalize">{maintenance.date}</span> - <span class="text-primary-light">{maintenance.level || 'Schoonvegen'}</span></h1>
          <p class="fs-lg mb-4">Hieronder kun je het resultaat van ons onderhoud bekijken.<br/>Valt je iets op? Dan kun je tijdens kantooruren bellen met <a class="eg-fancy text-primary-light" href="tel:0031850014241">085 - 001 4241</a></p>
    		  {#if subscription}
    		    <a class="btn btn-primary lift" on:click="{event => { View.setView('subscription', {subscription}) }}">Terug naar Abonnement</a>
    		  {:else}
    		    <a class="btn btn-primary lift" on:click="{event => { View.setView('dashboard') }}">Terug naar Account</a>
    		  {/if}
        </div>
      </div>
    </div>
  </section>

  <section class="position-relative pt-8 pb-10 bg-dark">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-6">
		      <label for="maintenance_before" class="form-label text-white text-uppercase fw-bold"><span class="text-underline-warning">Voor</span> het Onderhoud</label>
          <img id="maintenance_before" class="position-relative img-fluid rounded" src="{maintenance.before}" alt="{maintenance.date}">
        </div>
        <div class="col-12 col-lg-6 mt-7 mt-lg-0">
    		  <label for="maintenance_before" class="form-label text-white text-uppercase fw-bold"><span class="text-underline-warning">Na</span> het Onderhoud</label>
          <img id="maintenance_after" class="position-relative img-fluid rounded" src="{maintenance.after}" alt="{maintenance.date}">
        </div>
      </div>
    </div>
  </section>
{/if}